import { useContext } from 'react';

import { TimezoneContext } from '@/shared/lib/contexts/timezone.context';

export const useTimezone = () => {
	return useContext(TimezoneContext);
};
